export default {
  NEW: `#graphql
  mutation NewBrand($name: String!, $copyBrand: String! ) {
    newBrand(name: $name, copyBrand: $copyBrand)        
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/brand.js